export type MonitoringGateAuthSlice = {
  isAuthenticated: boolean;
  isAdminPasswordVerified: boolean;
  loading: boolean;
};

/** 보호 경로 접근 불가 시 이동할 경로 (null이면 허용) */
export function resolveMonitoringGateRedirect(
  authState: MonitoringGateAuthSlice,
  options: { isIndividualPoolPath: boolean }
): '/login' | '/verify-admin' | null {
  if (authState.loading) return null;
  const isAdminLoggedIn =
    authState.isAdminPasswordVerified && authState.isAuthenticated;
  if (isAdminLoggedIn || options.isIndividualPoolPath) return null;
  if (authState.isAdminPasswordVerified && !authState.isAuthenticated) {
    return '/login';
  }
  return '/verify-admin';
}

export function isHttp401(err: unknown): boolean {
  if (!err || typeof err !== 'object') return false;
  const status = (err as { response?: { status?: number } }).response?.status;
  return status === 401;
}
